import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useRef } from 'react';
import parse from 'html-react-parser';
import UpdateEditor from './UpdateEditor';

function EditorsDash({ showMessage, title_page }) {

    useEffect(() => {
            document.title = title_page;
    }, [title_page]);

    const navigate = useNavigate();

    const [activeTab, setActiveTab] = useState("view");

    const tabActivated = (tabName) => {
        navigate(`?tab=${tabName}`);
        if(tabName === "view"){
            setActiveTab("view");
            setShowUpdate(false);
        }else{
            setActiveTab("create");
        }
    };

    const [title, setTitle] = useState("");
    const [education, setEducation] = useState("");
    const [email, setEmail] = useState("");
    const [image, setImage] = useState("");
    const fileInputRef = useRef(null);

    const [currentEditorId, setCurrentEditorId] = useState("");

    const submitEditor = async () => {
        if (!title || !education || !email || !image) {
            showMessage("error", "All fields are required.");
            return;
        }

        const formData = new FormData();
        formData.append('title', title);
        formData.append('education', education);
        formData.append('email', email);
        formData.append('image', image);

        try {
            const response = await fetch('https://annalsofnursing.org/aon_backend/api/api.php?action=submitEditor', {
            method: 'POST',
            credentials: "include",
            body: formData,
            });

            const data = await response.json();
            if (data.success) {
            showMessage("success", "Profile submitted successfully!");

            reloadEditor();

            tabActivated("view");

            setTimeout(()=>{
                window.location.reload()
            },1000)
            
            } else {
            showMessage("error", data.error || "Submission failed.");
            }
        } catch (err) {
            showMessage("error", err);
        }
    };

    const reloadEditor = () =>{
        setTitle("");
        setEducation("");
        setEmail("");
        setImage("");
        if (fileInputRef.current) {
            fileInputRef.current.value = "";
        }
    }

    useEffect(() => {
            fetch('https://annalsofnursing.org/aon_backend/api/api.php?action=checkUserSession', {
                    method: 'GET',
                    credentials: "include",
                })
                .then(response => response.json())
                .then(data => {
                    if (data.success !== 'true') {
                        navigate("/dashboard/login")
                    }
                })
                .catch(error => {
                    console.log(error)
                });
    }, []);

    const dashLogout = () =>{
        fetch('https://annalsofnursing.org/aon_backend/api/api.php?action=removeUserSession', {
                method: 'GET',
                credentials: "include",
            })
            .then(response => response.json())
            .then(data => {
                console.log(data)
                if (data.success === 'true') {
                    showMessage("success", "Logged Out!");
                    navigate("/dashboard/login")
                }
            })
            .catch(error => {
                showMessage("error", "Something went wrong.");
        });
    }


    //Show editors
    const [editors, setEditors] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 10;

    useEffect(() => {
        fetch("https://annalsofnursing.org/aon_backend/api/api.php?action=getAllEditors")
            .then(response => response.json())
            .then(data => {
                if (data.success) {
                    setEditors(data.editors);
                } else {
                    console.error("API Error:", data.error);
                }
            })
            .catch(error => console.error("Error fetching editors:", error));
    }, []);


    // Pagination logic
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = editors.slice(indexOfFirstItem, indexOfLastItem);
    const totalPages = Math.ceil(editors.length / itemsPerPage);

    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
    };


    const deleteEditor = async (editorId) => {
        const confirmed = window.confirm("Are you sure you want to delete this editor?");
        if (!confirmed) return;

        try {
            const response = await fetch(`https://annalsofnursing.org/aon_backend/api/api.php?action=deleteEditor`, {
                method: 'POST',
                credentials: "include",
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ id: editorId }),
            });

            const data = await response.json();

            if (data.success) {
                showMessage("success", "Editor deleted successfully.");
                setTimeout(()=>{
                    window.location.reload()
                },1000)

            } else {
                showMessage("error", data.error);
            }
        } catch (err) {
            showMessage("error", err.message);
        }
    };

    const [showUpdate, setShowUpdate] = useState(false);

    const updateEditor = (editorId) =>{
        setCurrentEditorId(editorId);
        setShowUpdate(true);
    }

    const dashBack = () =>{
        navigate("/dashboard")
    }

    return (
      <>
        <div className='dash_section'>
            <div className="dash_wrapper">

                <div className='dash_logout'>
                    <div className='dash_back_cta' onClick={() => dashBack()}>
                        Dashboard
                    </div>
                    <div className='dash_logout_cta' onClick={() => dashLogout()}>
                        Logout
                    </div>
                </div>

                <div className='dash_header_tabs'>
                    <div className='dash_header_tab' onClick={() => tabActivated('view')} style={activeTab === "view" ? { borderBottom: '2px solid gray' } : {}}>
                        View Editors

                    </div>
                    <div className='dash_header_tab' onClick={() => tabActivated('create')} style={activeTab === "create" ? { borderBottom: '2px solid gray' } : {}}>
                        Add New Editor
                    </div>
                </div>
                
                <div className='dash_body_tab' style={activeTab === "view" ? { display: 'block' } : {display: 'none'}}>
                    
                    {showUpdate === false ?
                    <div>

                        <h2 className='dash_body_title'>Editorial Board - View</h2>
                    
                        <div className='dash_table_wrapper'>
                            <div className='dash_table_body'>
                                {currentItems.map((editor) => (
                                    <div key={editor.id} className='dash_table_body_wrapper'>

                                        <p className='dash_table_info_education'><strong>ID:</strong> {editor.id}</p>

                                        <div className='dash_table_info'>
                                            <div className='dash_table_info_image'>
                                                <img
                                                    src={editor.image}
                                                    alt={editor.title}
                                                />
                                            </div>
                                            <div className='dash_table_info_content'>
                                                <p className='dash_table_info_title'>{parse(editor.title)}</p>
                                                <p className='dash_table_info_email'>{parse(editor.email)}</p>
                                            </div>
                                            
                                        </div>

                                        <p className='dash_table_info_education'><strong>Education:</strong> {parse(editor.education)}</p>

                                        <div className='dash_table_info_actions'>
                                            <button className='dash_table_info_action' onClick={()=> updateEditor(editor.id)}>Update</button>
                                            <button className='dash_table_info_action info_action_delete' onClick={()=>deleteEditor(editor.id)}>Delete</button>
                                        </div>    
                                    </div>
                                ))}
                            </div>
                        </div>

                        {/* Pagination */}
                        <div style={{ marginTop: "1rem", textAlign: "center", display: "flex", justifyContent: "center", alignItems: "center", gap: "1rem" }}>
                            
                            {/* Left Arrow */}
                            <button
                                onClick={() => handlePageChange(currentPage - 1)}
                                disabled={currentPage === 1}
                                style={{
                                    height: "40px",
                                    width:"40px",
                                    backgroundColor: "#eee",
                                    color: "#000",
                                    border: "none",
                                    borderRadius: "100px",
                                    cursor: currentPage === 1 ? "not-allowed" : "pointer",
                                    opacity: currentPage === 1 ? 0.5 : 1
                                }}
                            >
                                <span className="fa-solid fa-arrow-left"></span>
                            </button>

                            {/* Page Info */}
                            <span>
                                Page {currentPage} of {totalPages}
                            </span>

                            {/* Right Arrow */}
                            <button
                                onClick={() => handlePageChange(currentPage + 1)}
                                disabled={currentPage === totalPages}
                                style={{
                                    height: "40px",
                                    width:"40px",
                                    backgroundColor: "#eee",
                                    color: "#000",
                                    border: "none",
                                    borderRadius: "100px",
                                    cursor: currentPage === totalPages ? "not-allowed" : "pointer",
                                    opacity: currentPage === totalPages ? 0.5 : 1
                                }}
                            >
                                <span className="fa-solid fa-arrow-right"></span>
                            </button>
                        </div>
                    </div>            
                     : 

                     <>
                        <h2 className='dash_body_title'>Editorial Board - Update Editor</h2>

                        <UpdateEditor id={currentEditorId} showMessage={showMessage} setShowUpdate={setShowUpdate}/>
                     </>              
                    

                    }
                </div>

                <div className='dash_body_tab' style={activeTab === "update" ? { display: 'block' } : {display: 'none'}}>
                    <h2 className='dash_body_title'>Editorial Board - Update</h2>

                </div>

                <div className='dash_body_tab' style={activeTab === "create" ? { display: 'block' } : {display: 'none'}}>
                    <h2 className='dash_body_title'>Editorial Board - Add New Editor</h2>


                    <div className='dash_update_records'>
                        <label>1. Title</label><br/>
                        <input className='dash_input' type="text" value={title} onChange={(e) => setTitle(e.target.value)} /><br/>

                        <label>2. Education</label><br/>
                        <input className='dash_input' type="text" value={education} onChange={(e) => setEducation(e.target.value)} /><br/>

                        <label>3. Email</label><br/>
                        <input className='dash_input' type="email" value={email} onChange={(e) => setEmail(e.target.value)} /><br/>

                        <label>4. Upload Image</label><br/>
                        <input ref={fileInputRef} className='dash_file_upload' type="file" onChange={(e) => setImage(e.target.files[0])} /><br/>

                        <br/><br/>
                        <div className='dash_buttons_wrapper'>
                            <button className='dash_form_buttom' onClick={()=>submitEditor()}>Submit</button>
                            <button className='dash_form_buttom dash_reset' onClick={()=>reloadEditor()}>Reset</button>
                        </div>
                        
                    </div>

                </div>
                
                
            </div>
        </div>
      </>
    );
}

export default EditorsDash;